import { createSelector } from "@reduxjs/toolkit";
import { IAccommodationReservation, IAccommodationReservationWithBlock } from "Bands/types";
import { mapKeys, reduce } from "lodash-es";
import { API_ENDPOINTS } from "shared/constants";

import { IDataKeys } from "shared/types";
import { buildData } from ".";
import { dataSelector } from "./helpers";

export const customAccommodationReservationsSelector = (blockId: string) =>
  createSelector(dataSelector, data => {
    const reservations = (buildData(data as any, IDataKeys.eventAccommodationReservation) ||
      []) as IAccommodationReservationWithBlock[];

    return reservations.filter(
      reservation =>
        reservation.accommodationBlock.id === API_ENDPOINTS.EVENT_ACCOMMODATION_BLOCK(blockId)
    );
  });

export const customAccommodationReservationSelector = createSelector(
  dataSelector,
  data =>
    (buildData(data as any, IDataKeys.eventAccommodationReservation) ||
      []) as IAccommodationReservation[]
);

export const accommodationReservationSelectorCreator = (reservationPaths?: string[]) =>
  createSelector(customAccommodationReservationSelector, reservations => {
    return mapIdsToReservations(reservationPaths, reservations);
  });

const mapIdsToReservations = (
  reservationPaths: string[] = [],
  reservations: IAccommodationReservation[]
) => {
  const reservationsMap = mapKeys(reservations, ({ id }) =>
    API_ENDPOINTS.EVENT_ACCOMMODATION_RESERVATION(id)
  );

  return reduce(
    reservationPaths,
    (selectedReservations: IAccommodationReservation[], path) => {
      const selectedReservation = reservationsMap?.[path];

      if (selectedReservation) {
        return [...selectedReservations, selectedReservation];
      }

      return selectedReservations;
    },
    []
  );
};
